import { Actions } from './reducer';
import * as Selectors from './selectors';
import * as LoginManager from '../../ui/login';
import { store } from '../../../core/Store';
import { ToastsManager } from 'toasts';
import * as Api from './api';
import { KwardaErrorTimeout, KwardaLoginError } from '../../../models/Global';

export { Actions, Selectors };

export const loginApp = async () => {
	const canLogin = LoginManager.Selectors.getCanSave(store.getState());

	if (!canLogin) {
		return ToastsManager.pushToast({
			content: 'Podane dane nie są poprawne',
			alertProps: {
				severity: 'error',
			},
			autoHideDuration: 5000,
		});
	}

	store.dispatch(Actions.setIsDataLoaded(false));

	const data = LoginManager.Selectors.getData(store.getState());

	const payload: LoginPayload = {
		login: data.login,
		haslo: btoa(data.password),
	};

	const { data: loginData, success: loginSuccess } = await Api.login(payload);

	if (!loginSuccess || (loginData as KwardaLoginError)?.bledy) {
		ToastsManager.pushToast({
			content: (loginData as KwardaLoginError)?.bledy
				.map((el) =>
					typeof el === 'object' ? el.error : (el as string)
				)
				.join(),
			alertProps: {
				severity: 'error',
			},
			autoHideDuration: 5000,
		});

		// @ts-ignore
		if (loginData?.bledy.find((el) => typeof el === 'object')) {
			// @ts-ignore
			const err = loginData?.bledy.filter(
				(el: any) => typeof el === 'object'
			) as KwardaErrorTimeout[];

			if (err.length > 1) {
				throw new Error('krzychu zabije cie');
			}

			store.dispatch(
				LoginManager.Actions.setSaveTimeout(parseInt(err[0].czas))
			);
		}

		return;
	}

	const { data: hasTwoFactorData, success: hasTwoFactorSuccess } =
		await Api.getHasTwoFactor();

	if (!hasTwoFactorSuccess) {
		throw new Error('Nie można pobrać informacji o 2FA');
	}

	if (hasTwoFactorData) {
		store.dispatch(LoginManager.Actions.setStep('confirm'));

		return;
	}

	window.location.replace('/');
};

export interface LoginPayload {
	login: string;
	haslo: string;
}

export interface LoginResponse {
	czas?: string;
	error?: string;
}
